// removed by extract-text-webpack-plugin
module.exports = {"dark-green":"#008300","ipad":"1024px","notification":"_5dC-G9QtIL8JoEyFskJGC","entered":"_3ela9Vk7E6yNNXBZznJu0y","actionSection":"_2TVlO6l2Rwo6sxAwXQnacS","informativeSection":"MbyXyc3zOFgvMvTQlOE5S","informativeTitle":"_1pkbuYP5nWPCiVXW-Dv6Pz","informativeDescription":"_36xfvFH7Ay_hhgFqZYllHu","closeButton":"_2PmKnAwgfDUwB1qO6owlci"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Notification/InlineNotification/InlineNotification.css
// module id = 1306
// module chunks = 0